import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { swSettings } from "app/common/services/swSettings";

const WelcomeTitle = () => {
    return (
        <>
            <Text
                fontVariant="h3"
                color={colorsPalettes.carbon[400]}
            >
                {translate("si.pages.ai_agent.welcome.text", {
                    user: (swSettings.user as { firstname: string }).firstname,
                })}
            </Text>
            <Text
                fontVariant="h3"
                color={colorsPalettes.carbon[400]}
            >
                {translate("si.pages.ai_agent.welcome.question")}
            </Text>
        </>
    );
};

export default WelcomeTitle;
